import { render, staticRenderFns } from "./InviteJoinResult.vue?vue&type=template&id=2fe5e9b3&scoped=true"
import script from "./InviteJoinResult.vue?vue&type=script&lang=js"
export * from "./InviteJoinResult.vue?vue&type=script&lang=js"
import style0 from "./InviteJoinResult.vue?vue&type=style&index=0&id=2fe5e9b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5e9b3",
  null
  
)

export default component.exports